import React from 'react';
import { Route } from 'react-router';

import { PATH } from '../constants/path';
import { BRAND_NAME, DIDOMI_VENDOR_GOOGLE_ID, DIDOMI_VENDOR_AT_INTERNET_ID } from '../constants';

import ModalRoot from './modal/ModalRoot';
import BannerRoot from './banner/BannerRoot';

import { HeadComponent } from './HeadComponent';
import RouterComponent from './router/RouterComponent';
import ScrollToTopComponent from './ScrollToTopComponent';
import AnalyticsComponent from './google/AnalyticsComponent';
import SmartTagComponent from './smarttag/SmartTagComponent';
import LocalizedBreadcrumbItem from './breadcrumb/LocalizedBreadcrumbsItem';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = { enableAnalytics: false, enableSmartTag: false };
    }

    componentDidMount() {
        if (window.Didomi) {
            const shouldEnableAnalytics =
                window.Didomi.getUserConsentStatusForVendor(DIDOMI_VENDOR_GOOGLE_ID) || false;
            const shouldEnableSmartTag =
                window.Didomi.getUserConsentStatusForVendor(DIDOMI_VENDOR_AT_INTERNET_ID) || false;

            this.setState({
                enableAnalytics: shouldEnableAnalytics,
                enableSmartTag: shouldEnableSmartTag
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (window.Didomi) {
            const shouldEnableAnalytics =
                window.Didomi.getUserConsentStatusForVendor(DIDOMI_VENDOR_GOOGLE_ID) || false;
            const shouldEnableSmartTag =
                window.Didomi.getUserConsentStatusForVendor(DIDOMI_VENDOR_AT_INTERNET_ID) || false;

            if (prevState.enableAnalytics !== shouldEnableAnalytics) {
                this.setState({ enableAnalytics: shouldEnableAnalytics });
            }
            if (prevState.enableSmartTag !== shouldEnableSmartTag) {
                this.setState({ enableSmartTag: shouldEnableSmartTag });
            }
        }
    }

    render() {
        return (
            <div id="app">
                <AnalyticsComponent enable={this.state.enableAnalytics} />
                <SmartTagComponent enable={this.state.enableSmartTag} />
                <HeadComponent title={BRAND_NAME} />
                <Route component={RouterComponent} />
                <LocalizedBreadcrumbItem to={PATH.HOME_PATH}>{BRAND_NAME}</LocalizedBreadcrumbItem>
                <ModalRoot />
                <BannerRoot />
                <ScrollToTopComponent />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js